import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Avatar } from "@/components/ui/avatar";
import { AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import Layout from "@/components/Layout";
import { Mail, LogOut } from "lucide-react";
import { Link } from "react-router-dom";

const NoAccess = () => {
  // Avatar gegevens voor de onderste sectie
  const avatarUsers = [{
    initial: "A"
  }, {
    initial: "B"
  }, {
    initial: "R"
  }, {
    initial: "H"
  }, {
    initial: "M"
  }, {
    initial: "E"
  }, {
    initial: "V"
  }];
  
  const handleRequestAccess = () => {
    window.location.href = "mailto:info@beterturnen.nl";
  };
  
  return <Layout className="flex items-center justify-center p-4 bg-gray-50">
      <div className="max-w-md w-full">
        <Card className="p-8 shadow-md border-gray-100">
          <div className="flex flex-col items-center space-y-6">
            {/* Icoon aan de bovenkant */}
            <div className="w-24 h-24 rounded-full bg-green-50 flex items-center justify-center">
              <div className="w-10 h-12 border-2 border-green-500 rounded-t-md relative">
                <div className="absolute w-1 h-1 bg-green-500 rounded-full left-1/2 top-1/2 transform -translate-x-1/2"></div>
              </div>
            </div>

            {/* Titel en subtitel */}
            <div className="text-center space-y-2">
              <h1 className="text-3xl font-bold">Turnles Planner staat voor je klaar!</h1>
              <p className="text-xl text-gray-500">Deze tool is exclusief voor leden van Turnles Planner.</p>
            </div>

            {/* Primaire actieknop */}
            <Button asChild className="w-full py-6 bg-green-500 hover:bg-green-600 text-white font-medium text-lg">
              <a href="https://beterturnen.nl/turnles-planner/" target="_blank" rel="noopener noreferrer">Ontdek wat je met Turnles Planner kunt doen</a>
            </Button>

            {/* Toegang aanvragen knop */}
            <Button variant="outline" className="w-full py-6 text-black border-gray-200 hover:bg-gray-50 font-medium text-lg" onClick={handleRequestAccess}>
              <Mail className="mr-2" size={20} /> Toegang aanvragen
            </Button>

            {/* Informatieve tekst */}
            <p className="text-gray-500 text-center">
              Al toegang gekocht, maar nog geen toegang? Laat het ons weten – we zetten je account binnen 1 werkdag actief.
            </p>

            {/* Avatars en gebruikerstelling */}
            <div className="flex flex-col items-center space-y-3">
              <div className="flex -space-x-2">
                {avatarUsers.map((user, index) => <Avatar key={index} className="border-2 border-white w-8 h-8">
                    <AvatarFallback>{user.initial}</AvatarFallback>
                  </Avatar>)}
              </div>
              <p className="text-gray-600">
                <strong>286 turncoaches</strong> gebruiken Turnles Planner al dagelijks.
              </p>
            </div>

            {/* Uitloggen knop */}
            <Button variant="outline" className="w-full py-6 text-gray-500 border-gray-200 hover:bg-gray-50 font-medium text-lg" asChild>
              <Link to="/auth/login">
                <LogOut className="mr-2" size={20} /> Uitloggen
              </Link>
            </Button>
          </div>
        </Card>
      </div>
    </Layout>;
};

export default NoAccess;
